var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="registerTmp_empty"> <section class="page-info-block"> <div class="container"> <div class="page-info clearfix"> <ol class="breadcrumb pull-left"> <li><a href="#Index"><i class="fa fa-home"></i></a></li> <li class="active">'+
((__t=( resources['X100602'] ))==null?'':__t)+
'</li> <li class="active">'+
((__t=( resources['X100602'] ))==null?'':__t)+
'</li> </ol> </div> </div> </section> <section class="content-block page-bg"> <div class="overlay tint"> <div class="container"> <div class="row"> <div class="col-sm-12 col-md-12 vspace-xs"> <h4>'+
((__t=( resources['X100602'] ))==null?'':__t)+
'</h4> <p>'+
((__t=( resources['X100943'] ))==null?'':__t)+
'</p> </div> </div> </div> </div> </section> </div>';
}
return __p;
};
